@if (componentData$ | async; as data) {
  <div class="custom-align-center">
    <a routerLink="{{data.url}}" target="_blank" class="nav-link secondary-anchor header-faq custom-align-center">
      {{data.linkName}}
    </a>
  </div>
}